import {ProductFeature} from "@/models/scope/productSheet/ProductFeature";
import React, {VoidFunctionComponent} from "react";

export const FeatureBody: VoidFunctionComponent<{ feature: ProductFeature }> = ({feature}) => {

    return (
        <div className='feature-block-body'>
            <div className='label'>{feature.label}</div>
            <div className='value'>{feature.value}</div>
        </div>
    );

};